/* Razvan Garage – codul pachetului „Cumpărate frecvent împreună” se pune singur în coș.
   Când în coș sunt cel puțin 2 produse din același pachet (produsul și piesele lui), oricum ar fi fost adăugate,
   codul pachetului (IMPREUNA-…) se adaugă lângă codurile deja puse. Clientul nu tastează nimic.
   Datele pachetelor vin din secțiunea rg-pachete-cos (metafield-urile custom.cumparate_impreuna*). */
(() => {
  if (window.rgPacheteCos) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const json = {'Content-Type': 'application/json', Accept: 'application/json'};
  let running = false;
  let again = false;

  async function sync() {
    if (running) { again = true; return false; }
    running = true;
    let changed = false;
    try {
      const [sec, cartRes] = await Promise.all([
        fetch(root + '?sections=rg-pachete-cos', {credentials: 'same-origin'}),
        fetch(root + 'cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}})
      ]);
      if (!sec.ok || !cartRes.ok) return false;
      const match = ((await sec.json())['rg-pachete-cos'] || '').match(/<script[^>]*data-rg-pachete-cos[^>]*>([\s\S]*?)<\/script>/);
      if (!match) return false;
      const packs = JSON.parse(match[1]);
      const cart = await cartRes.json();
      const inCart = new Set(cart.items.map((item) => item.product_id));
      const codes = (cart.discount_codes || []).map((d) => d.code).filter(Boolean);
      const has = new Set(codes.map((c) => c.toUpperCase()));
      const prezente = (pack) => [...new Set(pack.products.filter((id) => inCart.has(id)))];
      // Produsele acoperite deja de un cod de pachet din coș: același cuplu (ex. kit galerie + kit EGR) poate fi în
      // pachetul fiecăruia; al doilea cod nu s-ar aplica și ar apărea în coș ca „neaplicabil”.
      const acoperite = new Set();
      packs.filter((p) => p.code && has.has(p.code.toUpperCase())).forEach((p) => prezente(p).forEach((id) => acoperite.add(id)));
      const add = [];
      packs
        .filter((p) => p.code && !has.has(p.code.toUpperCase()) && prezente(p).length >= 2)
        .sort((a, b) => prezente(b).length - prezente(a).length || b.percent - a.percent)
        .forEach((pack) => {
          const ids = prezente(pack);
          if (ids.every((id) => acoperite.has(id)) || has.has(pack.code.toUpperCase())) return;
          add.push(pack);
          has.add(pack.code.toUpperCase());
          ids.forEach((id) => acoperite.add(id));
        });
      if (!add.length) return false;
      const before = cart.total_discount || 0;
      const up = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: json,
        body: JSON.stringify({discount: [...codes, ...add.map((p) => p.code)].join(',')})
      });
      if (!up.ok) return false;
      // răspunsul de la cart/update.js nu are încă reducerea calculată; se recitește coșul
      const after = await (await fetch(root + 'cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}})).json();
      changed = true;
      refreshCart();
      const saved = (after.total_discount || 0) - before;
      if (saved > 0) notify(`Ai în coș produse din același pachet: reducerea de pachet s-a aplicat (−${money(saved)}).`);
    } catch (error) {
      console.log(error); // eslint-disable-line
    } finally {
      running = false;
      if (again) { again = false; sync(); }
    }
    return changed;
  }

  function money(cents) {
    return (cents / 100).toLocaleString('ro-RO', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' lei';
  }

  function refreshCart() {
    const drawer = document.querySelector('cart-drawer');
    const items = document.querySelector('cart-items');
    if (drawer && typeof drawer.refresh === 'function') drawer.refresh(true);
    else if (items && typeof items.refresh === 'function') items.refresh();
  }

  // Mesaj scurt pentru client, sus pe ecran (dispare singur sau la clic) – la fel ca la garanția de schimb.
  function notify(text) {
    const box = document.createElement('div');
    box.setAttribute('role', 'status');
    box.textContent = text;
    box.style.cssText = 'position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:2147483000;width:max-content;max-width:min(92vw,520px);'
      + 'padding:12px 16px;border:1px solid #b9e4c9;border-left:6px solid #1f9d55;border-radius:10px;background:#effaf3;color:#23272f;'
      + 'font-size:14px;line-height:1.45;box-shadow:0 6px 24px rgba(0,0,0,.18);cursor:pointer;';
    box.addEventListener('click', () => box.remove());
    document.body.appendChild(box);
    setTimeout(() => box.remove(), 7000);
  }

  // După orice schimbare a coșului și la încărcarea paginii (după garanția de schimb, care poate schimba coșul).
  const later = () => setTimeout(sync, 1400);
  document.addEventListener('on:cart:add', later);
  document.addEventListener('on:line-item:change', later);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later);
  else later();

  window.rgPacheteCos = {sync};
})();
